import { writable, type Writable } from "svelte/store";
import { windowWidth } from "../store";
import { MOBILE_SCREEN_WIDTH } from "../global";

export enum LibraryLayouts {
    DockedRight = "DockedRight",
    DockedBottom = "DockedBottom",
    Mobile = "Mobile",
}

let lastDesktopLayout = LibraryLayouts.DockedBottom;

export const libraryLayout = writable(LibraryLayouts.DockedBottom);
windowWidth.subscribe((width) => {
    if (width <= MOBILE_SCREEN_WIDTH) {
        libraryLayout.set(LibraryLayouts.Mobile);
    } else {
        libraryLayout.set(lastDesktopLayout)
    }
});

export function changeDesktopLayout(newLayout: LibraryLayouts) {
    libraryLayout.set(newLayout);
    lastDesktopLayout = newLayout;
}

const THIRTY_DAYS_AGO: Date = new Date(new Date().setDate(new Date().getDate() - 30));
export function isNewSound(publicSound): boolean {
  return publicSound.DateCreated !== null && new Date(publicSound.DateCreated) >= THIRTY_DAYS_AGO;
}

export enum LibraryState {
    Closed = "Closed",
    Open = "Open",
    Opening = "Opening",
    // Closing = "Closing", -- Unused for now, so we don't need to track it. A closing library is "Open"
}

export const libraryState: Writable<LibraryState> = writable(LibraryState.Closed);

